export default "__VITE_ASSET__CcuuC7yV__"